import { render, staticRenderFns } from "./GeneralActivities.vue?vue&type=template&id=34ee2006"
import script from "./GeneralActivities.vue?vue&type=script&lang=js"
export * from "./GeneralActivities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports